import { render, staticRenderFns } from "./WarningBarRoot.vue?vue&type=template&id=e6fd0bf6"
import script from "./WarningBarRoot.vue?vue&type=script&lang=ts"
export * from "./WarningBarRoot.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports